


















import { Vue, Component } from "vue-property-decorator";
import PopupComponent from "@/components/base/PopupComponent.vue";
import { Action } from "vuex-class";

@Component({
  name: "error-boundary",
  components: {
    PopupComponent,
  },
})
export default class ErrorBoundary extends Vue {
  private errorMessage: string = "";
  private showCancel: boolean = false;
  private closeButtonLabel: string = "Close";
  private modalClasses: string = "modal-danger";
  private onCloseAction: any;
  private showClose = false;
  private fixed = false;

  @Action("setOnline")
  public setOnline!: (payload: boolean) => Promise<void>;

  public errorCaptured(error: any, vm: Vue, info: string): boolean {
    this.fixed = !!(error && error.fixed);

    this.errorCustomHandler(error) ||
      this.authError(error) ||
      this.notifyError(error) ||
      this.networkError(error) ||
      this.appIdleError(error) ||
      this.appFatalError(error) ||
      this.defaultErrorHandller(error);

    // if (process.env.toLowerCase() === "dev") {
    //   console.log(error);
    // }

    return false;
  }

  public created() {
    window.addEventListener("online", this.showOnline);
    window.addEventListener("offline", this.showOffline);
  }

  public destroyed() {
    window.removeEventListener("online", () => {
      return;
    });
    window.removeEventListener("offline", this.networkError);
  }

  private onClose() {
    this.errorMessage = "";
    if (this.onCloseAction) {
      this.onCloseAction();
    }
  }

  public get hasError(): boolean {
    return !!this.errorMessage;
  }

  public get error(): string {
    return this.errorMessage;
  }

  private defaultErrorHandller(error: any): boolean {
    this.errorMessage =
      (error && error.data && error.data.message) ||
      "An unknown error occurred. Check your internet connection and try again.";
    return true;
  }

  private errorCustomHandler(err: any): boolean {
    if (err && err.type === "CUSTON_ERROR") {
      if (err && err.data.hasOwnProperty("closeButtonLabel")) {
        this.showCancel = true;
        this.closeButtonLabel = err.data.closeButtonLabel;
      }

      if (err && err.data.hasOwnProperty("modalClasses")) {
        this.modalClasses = this.modalClasses + " " + err.data.modalClasses;
      }

      this.onCloseAction = async () => {
        await this.$router.push("/logout");
      };

      this.errorMessage = err.data.message;
      return true;
    }

    return false;
  }

  private authError(err: any): boolean {
    if (err && err.status === 401) {
      window.location.href = "/logout";
      return true;
    }

    return false;
  }

  private notifyError(err: any): boolean {
    if (err && err.status === 420) {
      Vue.notify({
        type: "error",
        duration: 2000,
        group: "error",
        title: "An error ocurred",
        text: err.data.message,
      });

      return true;
    }

    return false;
  }

  private networkError(err: any): boolean {
    if (!err) {
      Vue.notify({
        type: "error",
        duration: 2000,
        group: "error",
        title: "An error ocurred",
        text:
          "An unknown error occurred. Check your internet connection and try again.",
      });

      return true;
    }

    return false;
  }

  private appIdleError(err: any): boolean {
    if (err && err.status === 428) {
      this.errorMessage =
        "You have been inactive for a long time. Please, exit and restart the assessment.";
      this.showCancel = true;
      this.showClose = true;

      this.onCloseAction = async () => {
        await this.$router.push("/logout");
      };

      return true;
    }

    return false;
  }

  private showOffline(err: any): void {
    this.setOnline(false);

    this.errorMessage =
      this.$route.name === "assessment"
        ? ""
        : "An unknown error occurred. Check your internet connection and try again.";
  }

  private showOnline(err: any): void {
    this.setOnline(true);

    if (!this.fixed) {
      this.errorMessage = "";
    }
  }

  private appFatalError(err: any): boolean {
    if (err && err.data && (err.status === 500 || err.status === 504)) {
      this.errorMessage = err.data.message =
        "An unknown error occurred. Check your internet connection and try again.";
      return true;
    }

    return false;
  }
}
